export const CUSTOM_FONTS = [
    {
        label: 'Abhaya Libre',
        value: 'font-family: \'Abhaya Libre\', serif',
        url: 'https://fonts.googleapis.com/css2?family=Abhaya+Libre',
    },
    {
        label: 'Merriweather',
        value: '\'Merriweather\', serif',
        url: 'https://fonts.googleapis.com/css2?family=Merriweather',
    },
    {
        label: 'Alegreya',
        value: '\'Alegreya\', serif',
        url: 'https://fonts.googleapis.com/css2?family=Alegreya',
    },
    {
        label: 'Aleo',
        value: '\'Aleo\', serif',
        url: 'https://fonts.googleapis.com/css2?family=Aleo',
    },
    {
        label: 'Muli',
        value: '\'Mulish\', sans-serif',
        url: 'https://fonts.googleapis.com/css2?family=Muli',
    },
    {
        label: 'Arapey',
        value: '\'Arapey\', serif',
        url: 'https://fonts.googleapis.com/css2?family=Arapey',
    },
    {
        label: 'Nunito',
        value: '\'Nunito\', sans-serif',
        url: 'https://fonts.googleapis.com/css2?family=Nunito',
    },
    {
        label: 'Asap Condensed',
        value: '\'Asap Condensed\', sans-serif',
        url: 'https://fonts.googleapis.com/css2?family=Asap+Condensed',
    },
    {
        label: 'Assistant',
        value: '\'Assistant\', sans-serif',
        url: 'https://fonts.googleapis.com/css2?family=Assistant',
    },
    {
        label: 'Barlow',
        url: 'https://fonts.googleapis.com/css2?family=Barlow',
        value: '\'Barlow\', sans-serif',
    },
    {
        label: 'Oswald',
        url: 'https://fonts.googleapis.com/css2?family=Oswald',
        value: '\'Oswald\', sans-serif',
    },
    {
        label: 'Bitter',
        url: 'https://fonts.googleapis.com/css?family=Bitter',
        value: '\'Bitter\', serif',
    },
    {
        label: 'Poppins',
        url: 'https://fonts.googleapis.com/css?family=Poppins',
        value: '\'Poppins\', sans-serif',
    },
    {
        label: 'Brawler',
        value: '\'Brawler\', serif',
        url: 'https://fonts.googleapis.com/css?family=Brawler',
    },
    {
        label: 'Roboto',
        value: '\'Roboto\', sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Roboto',
    },
    {
        label: 'Caladea',
        value: '\'Caladea\', serif',
        url: 'https://fonts.googleapis.com/css?family=Caladea',
    },
    {
        label: 'Rokkitt',
        value: '\'Rokkitt\', serif',
        url: 'https://fonts.googleapis.com/css?family=Rokkitt',
    },
    {
        label: 'Carme',
        value: '\'Carme\', sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Carme',
    },
    {
        label: 'Encode Sans Semi Condensed',
        value: '\'Encode Sans Semi Condensed\', sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Encode+Sans+Semi+Condensed',
    },
    {
        label: 'Enriqueta',
        value: '\'Enriqueta\', serif',
        url: 'https://fonts.googleapis.com/css?family=Enriqueta',
    },
    {
        label: 'Frank Ruhl Libre',
        value: '\'Frank Ruhl Libre\', serif',
        url: 'https://fonts.googleapis.com/css?family=Frank+Ruhl+Libre',
    },
    {
        label: 'Spectral',
        value: '\'Spectral\', serif',
        url: 'https://fonts.googleapis.com/css?family=Spectral',
    },
    {
        label: 'Work Sans',
        value: '\'Work Sans\', sans-serif',
        url: 'https://fonts.googleapis.com/css?family=Work+Sans',
    },
    {
        label: 'Gelasio',
        value: '\'Gelasio\', serif',
        url: 'https://fonts.googleapis.com/css?family=Gelasio',
    },
    {
        label: 'Headland One',
        value: '\'Headland One\', serif',
        url: 'https://fonts.googleapis.com/css?family=Headland+One',
    },
    {
        label: 'Great Vibes',
        value: '\'Great Vibes\', cursive',
        url: 'https://fonts.googleapis.com/css?family=Great+Vibes',
    },
    {
        label: 'Griffy',
        value: '\'Griffy\', cursive',
        url: 'https://fonts.googleapis.com/css?family=Griffy',
    },
];
